export default __webpack_public_path__ + "static/media/phone-ringing.e782123c.svg";